export default __webpack_public_path__ + "ec53c560c1e06e7919baf4335c0b2255c95cbd332111f98e21bf12acb91fef68.svg";